<template>  
  <modal v-model="show"
         max-width="500"
         :has-padding="false">          
    <v-icon size="20"
            slot="activator"
            v-tooltip="$t('message.generics.message.view')">mdi-key</v-icon>

    <div>
      <div class="form-body">
        <h1 class="text-muted text-center">
          {{$t('message.api.message.newApi')}}
        </h1>
        <h4 class="text-muted text-center">
            {{$t('message.api.message.apiRegistration')}}
        </h4>
        <text-field :value="clientId"
                    :label="$t('message.api.message.clientId')"
                    validate="required"
                    name="Client Id"
                    :disabled="true"
                    :action="copyAction"
                    @action="copyValue" />
        <text-field :value="clientSecret"
                    :label="$t('message.api.message.clientSecret')"
                    validate="required"
                    name="Client Secret"
                    :disabled="true"
                    :action="copyAction"
                    @action="copyValue" />
      </div>

      <div class="card-footer">
        <button class="btn btn-primary btn-round"
                @click="hide">
            {{$t('message.api.message.conclude')}}
        </button>
      </div>

    </div>
  </modal>  
</template>

<script>
import TextField from "@components/form/TextField.vue";
import EventBus from "@packages/event-bus";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    TextField,
    Modal
  },

  data() {
    return {
      show: false,
      clientId: "",
      clientSecret: "",
      copyAction: {
        label: this.$t('message.generics.message.copy'),
        icon: "mdi-content-copy",
      },
    };
  },

  props: {
    api: {
      type: Object,
    },
  },

  mounted() {
    this.clientId = this.api.id;
    this.clientSecret = this.api.clientSecret;
  },

  methods: {
    reset() {},
    async copyValue(value) {
      try {
        const type = "text/plain";
        const blob = new Blob([value], { type });
        // eslint-disable-next-line no-undef
        let data = [new ClipboardItem({ [type]: blob })];
        await navigator.clipboard.write(data);

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.textCopied'),
        });
      } catch (error) {
        console.log(error);
      }
    },
    hide() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-body {
  padding: 18px 50px 10px;

  h1 {
    font-weight: 600;
  }
}

.btn {
  margin-right: 10px;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.modal-round .v-card .card-body {
  min-height: 160px;
}
</style>
